// extracted by mini-css-extract-plugin
export default {"container":"ITServicesManagementPolicyPage_container__krbGd"};